
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  useMediaQuery,
} from "@material-ui/core";
import { useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { PANEL_KEY_HOSTNAME, PanelKeyHostname } from "../../Pages/ServicePanel/utils/constants";
import { getFromLocalStorage } from "../../utils/getFromLocalStorage";
import ConfirmRoomCreation from "../ConfirmRoomCreation";
import { useStyles } from "./style";
import { items } from "./items";
import { useAuth } from "../../contexts/auth";

export default function SideBar(): JSX.Element {
  const classes = useStyles();
  const { currentTicketOffice } = useAuth();
  const location = useLocation();
  const history = useHistory();
  const modalRef = useRef(null);
  const { pathname } = location;
  const matchesSm = useMediaQuery("(max-width:576px)");

  const hostnameData = getFromLocalStorage<PanelKeyHostname>(PANEL_KEY_HOSTNAME)?.hostname
  const goPage = (page: string, newTab: boolean = false) => {
    if (newTab) {
      window.open(page, '_blank');
    } else {
      history.push(page);
    }
  };

  const openConfirmationModal = () => {
    if (modalRef.current) {
      modalRef.current.openModal();
    }
  };

  const confirmAndOpenNewTab = () => {
    window.open(`/painel_de_atendimento/${hostnameData}`, "_blank");
  };

  return (
    <>
      {!matchesSm && (
        <Box className={classes.main}>
          <List className={classes.listMenu}>
            {items.map((item) => {
              if (item.isVisible(currentTicketOffice)) {
                return (
                  <ListItem
                    button
                    key={`sidebar-item-${item.href}`}
                    onClick={(): void => goPage(item.href)}
                  >
                    <ListItemIcon
                      className={classes.iconsMenu}
                      style={{
                        backgroundColor:
                          pathname === item.href
                            ? "#FFFFFF"
                            : "rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      {item.render ? (item.render) : (
                        <item.icon
                          style={{
                            color: pathname === item.href ? "#004F9F" : "#fff",
                          }}
                        />
                      )}
                    </ListItemIcon>
                  </ListItem>
                );
              } else {
                return null;
              }
            })}
            <ListItem button onClick={openConfirmationModal}>
              <ListItemIcon
                className={classes.iconsMenu}
                style={{
                  backgroundColor:
                    pathname === `/painel_de_atendimento/${hostnameData}`
                      ? "#FFFFFF"
                      : "rgba(255, 255, 255, 0.08)",
                }}
              >
                <img
                  src={"/assets/images/senha-da-web_white.png"}
                  alt="logo Atendimento"
                />
              </ListItemIcon>
            </ListItem>
          </List>
        </Box>
      )}
      <ConfirmRoomCreation
        ref={modalRef}
        title="Painel de atendimento"
        message="Você será redirecionado para o painel de atendimentos. Deseja continuar?"
        onConfirm={confirmAndOpenNewTab}
      />
    </>
  );
}
